import { DASHBOARD_URL } from 'config/app';
import postOneTimeToken from 'api/calls/postOneTimeToken';

const redirectToDashboard = async (): Promise<void> => {
  if (!DASHBOARD_URL) throw new Error('Dashboard URL not set in environment.');

  const { oneTimeToken } = await postOneTimeToken();

  sessionStorage.clear();
  localStorage.clear();

  if (!oneTimeToken) {
    window.location.replace(DASHBOARD_URL);
  } else {
    window.location.replace(
      `${DASHBOARD_URL}/one-time-token-login?token=${oneTimeToken}`,
    );
  }
};

export default redirectToDashboard;
